/**
 * ヘッダー定義用コンポーネント
 */
<template>
	<div id="footer">
		<!-- <hr> -->
		<div class="logo" style="display:none;">
			<img :src="url_logo" >
		</div>
		<!-- <div class="name" v-html="disp_copyright"></div> -->
		<div class="name">
			<span class="pp_link" v-html="disp_privacy_policy"></span>
			<span class="cr_text" v-html="disp_copyright"></span>
		</div>
		<div class="pgtop">
			<img class="pgtop" :src="url_pagetop" style="visibility:hidden;">
		</div>
	</div>
</template>
<script>
export default {
	mixins:[
		require('js/common/url.mixin.vue'),
	],
	props:[
	],
	computed:{
		url_logo:function(){
			return this.path_to_home + "img/digi_logo.png";
		},
		url_pagetop:function(){
			return this.path_to_home + "img/pagetop_btn.png";
		},
		disp_copyright:function() {
			var result = '';
			var currentDate = new Date();
			var currentYear = currentDate.getFullYear();
			result = 'Copyright ' + currentYear + '&copy; DIGI Group';
			return result;
		},
		disp_privacy_policy:function() {
			var result = '';
			result = 'Privacy Policy';
			return result;
		},
	},
    created:function(){
        $.getJSON('webinfo.json')
            .done(function(data, status, xhr){
                if ($('#footer').length) {
                    $('#footer').append('<!-- ' + data.comment + ' -->');
                }
            })
            .fail(function(xhr, status, e) {
                console.log('webinfo.json get error.');
            });
    },
	mounted:function(){
	    var pagetop = $('img.pgtop');
		pagetop.hide();
		pagetop.css("visibility","visible")

	    $(window).scroll(function () {
	        if ($(this).scrollTop() > 100) {
	            pagetop.fadeIn();
	        } else {
	            pagetop.fadeOut();
	        }
	    });
	    pagetop.click(function () {
	        $('body, html').animate({ scrollTop: 0 }, 500);
	        return false;
	    });

			// プライバシーポリシークリック
			$('#footer .pp_link').on('click', function () {
				/*
				var windowTop = window.innerHeight / 2;
				var windowLeft = window.innerWidth / 2;
				var dialogWidth = 800;
				var dialogHeight = 500;
				var axisX = windowLeft - (dialogWidth / 2);
				var axisY = windowTop - (dialogHeight / 2);
				var dialogWindow = window.open(pageUrl, null, 'top=' + axisY + ',left=' + axisX + ',width=' + dialogWidth + ',height=' + dialogHeight);
				if (!dialogWindow) dialogWindow.close();
				*/
				window.open('./help/privacy_policy.php', '_blank');
			});
	},
	methods: {
		// /**
		//  * window open
		//  * @param
		//  * @method openPageWindow
		//  */
		// openPageWindow: function(pageUrl) {
		// 	// var windowTop = window.innerHeight / 2;
		// 	// var windowLeft = window.innerWidth / 2;
		// 	// var dialogWidth = 800;
		// 	// var dialogHeight = 500;
		// 	// var axisX = windowLeft - (dialogWidth / 2);
		// 	// var axisY = windowTop - (dialogHeight / 2);
		// 	// var dialogWindow = window.open(pageUrl, null, 'top=' + axisY + ',left=' + axisX + ',width=' + dialogWidth + ',height=' + dialogHeight);
		// 	// if (!dialogWindow) dialogWindow.close();
		// 	var dialogWindow = null;
		// 	if (pageUrl) {
		// 		dialogWindow = window.open('', '_blank');
		// 		dialogWindow.location.href = pageUrl;
		// 		dialogWindow = null;
		// 	}
		// },
	},
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/parts_com/Footer.vue